import React, { Component } from "react";

import PropTypes from "prop-types";
import { View, TextInput, StyleSheet, I18nManager } from "react-native";
import Text from "./TextFont";
import ArTheme from "../argon-ui/Theme";
import { min } from "react-native-reanimated";
import { getIsRTL } from "../util";

/**
 * @augments {Component<props, state>}
 * */
class SimpleTimePicker extends Component {
  static propTypes = {
    value: PropTypes.string,
    fontSize: PropTypes.number,
    onChange: PropTypes.func,
    placeholderMin: PropTypes.string,
    placeholderHour: PropTypes.string,
  };

  constructor(props) {
    super(props);
    let time = this.props.value;
    var hour = undefined,
      minute = undefined;
    if (time) {
      var parts = time.split(":");
      hour = this.toTwoDigit(parts[0]);
      minute = this.toTwoDigit(parts[1]);
    }

    this.state = {
      hour,
      minute,
    };
  }
  handleOnChange() {
    let { hour, minute } = this.state;
    this.props.onChange &&
      this.props.onChange(
        `${this.toTwoDigit(hour)}:${this.toTwoDigit(minute)}`
      );
  }

  setHour(hour) {
    if (hour < 0 || hour > 23) return;
    this.setState({ hour }, () => this.handleOnChange());
  }

  setMinute(minute) {
    if (minute < 0 || minute > 59) return;

    this.setState({ minute }, () => this.handleOnChange());
  }

  //   increaseHour() {
  //     let { hour } = this.state;
  //     if (hour == 23) hour = "00";
  //     hour = Number(hour) + 1;
  //     this.setHour(hour);
  //   }

  //   increaseMinute() {
  //     let { minute, hour } = this.state;
  //     if (minute == 59) {
  //       minute = "00";
  //       this.increaseHour();
  //     } else {
  //       minute = Number(minute) + 1;
  //     }
  //     this.setMinute(minute);
  //   }

  toTwoDigit(num) {
    if (Number(num) >= 0) {
      return num && (100 + Number(num)).toString().substring(1);
    }

    return num;
  }

  render() {
    let { style } = this.props;
    if (!style) style = {};
    var fs = { fontSize: this.props.fontSize || 18 };
    return (
      <View
        style={[
          styles.container,
          {
            flexDirection: getIsRTL() ? "row-reverse" : "row",
          },
          style,
        ]}
      >
        <TextInput
          style={[styles.textInput, styles.hour, fs]}
          value={this.state.hour}
          onChangeText={(txt) => {
            var res = txt.replace(/[^0-9]/g, "");
            this.setHour(res);
          }}
          keyboardType="number-pad"
          placeholder={this.props.placeholderHour}
        />
        <Text style={styles.separator}>:</Text>
        <TextInput
          style={[styles.textInput, styles.minute, fs]}
          value={this.state.minute}
          onChangeText={(txt) => {
            var res = txt.replace(/[^0-9]/g, "");
            this.setMinute(res);
          }}
          keyboardType="number-pad"
          placeholder={this.props.placeholderMin}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
    width: "100%",
    borderColor: ArTheme.COLORS.BORDER_COLOR,
    borderWidth: 1,
    backgroundColor: "#FFF",
  },
  textInput: {
    flex: 1,
    textAlign: "center",
    width: "49%",
    // fontSize: 18,
    paddingVertical: 0,
  },
  separator: {
    fontSize: 16,
  },
  hour: {
    borderLeftWidth: 0,
  },
  minute: {
    borderRightWidth: 0,
  },
});

export default SimpleTimePicker;
